export enum ApiService {
  Properties = 'properties',
  Articles = 'articles',
  Files = 'files',
  ClientData = 'client-data',
  Maps = 'maps',
  CDN = 'cdn',
  // DEV-1015: agents-service — публичный резолв презентации по токену (/p/{token}).
  Agents = 'agents',
  // DEV-1857: landings-service — публичный приёмник просмотров (маячок сайта).
  Landings = 'landings',
}

const API_HOSTS: Record<ApiService, string> = {
  [ApiService.Properties]: import.meta.env.VITE_PROPERTIES_HOST || '',
  [ApiService.Articles]: import.meta.env.VITE_ARTICLES_HOST || '',
  [ApiService.Files]: import.meta.env.VITE_FILES_HOST || '',
  [ApiService.ClientData]: import.meta.env.VITE_CLIENT_DATA_HOST || '',
  [ApiService.Maps]: import.meta.env.VITE_MAPS_HOST || '',
  [ApiService.CDN]: import.meta.env.VITE_CDN_HOST || '',
  [ApiService.Agents]: import.meta.env.VITE_AGENTS_HOST || '',
  [ApiService.Landings]: import.meta.env.VITE_LANDINGS_HOST || '',
}

const USE_SINGLE_ENDPOINT = import.meta.env.VITE_USE_SINGLE_ENDPOINT === 'true'
const SINGLE_API_URL = import.meta.env.VITE_API_BASE_URL || 'https://dev.vinprop.vn'

/**
 * Строит URL для API запроса
 * @param service - Тип сервиса (properties, articles, и т.д.)
 * @param path - Путь без префикса /api/v1 (например, 'properties/rc/vinhomes')
 * @returns Полный URL для запроса
 */
export function buildApiUrl(service: ApiService, path: string): string {
  if (USE_SINGLE_ENDPOINT) {
    return `${SINGLE_API_URL}/api/v1/${path}`
  }

  const host = API_HOSTS[service]
  return `${host}/api/v1/${path}`
}

/**
 * Строит URL для CDN ресурса
 * @param path - Путь к ресурсу (например, "image-filename.jpg")
 * @returns Полный URL CDN
 */
export function getCdnUrl(path: string): string {
  // Убираем ведущий слеш если есть
  const cleanPath = path.startsWith('/') ? path.slice(1) : path

  // if (USE_SINGLE_ENDPOINT) {
  //   return `${SINGLE_API_URL}/cdn/${cleanPath}`
  // }

  const cdnHost = API_HOSTS[ApiService.CDN]
  return `${cdnHost}/${cleanPath}`
}
